import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

const FormControl = ({
  type,
  placeholder,
  name,
  value,
  onChange,
  isInvalid,
  feedback,
  height,
  borderRadius,
  className = "",
  isDisabled = false,
  suffix,
  autoComplete = "off",
  containerClassName = "",
}) => {
  const appliedHeight = height ? `${height}px` : "auto";
  const appliedborderRadius = borderRadius ? `${borderRadius}px` : "0px";

  return (
    <>
      <div className={`form-control-container ${containerClassName}`}>
        <Form.Control
          type={type}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={onChange}
          isInvalid={isInvalid}
          style={{
            height: appliedHeight,
            borderRadius: appliedborderRadius,
            paddingRight: suffix ? "2rem" : "1rem",
          }}
          className={className}
          disabled={isDisabled}
          autoComplete={autoComplete}
        />
        {suffix && <div className="suffix">{suffix}</div>}
        {isInvalid && (
          <Form.Control.Feedback type="invalid">
            {feedback}
          </Form.Control.Feedback>
        )}
      </div>
    </>
  );
};

FormControl.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  isInvalid: PropTypes.bool,
  feedback: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  suffix: PropTypes.node,
  containerClassName: PropTypes.string,
};

export default FormControl;
